import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid h-100" }
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  class: "d-flex mt-4",
  style: {"gap":"12px"}
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"150px"}
}
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 0,
  class: "mb-2 select-label"
}
const _hoisted_10 = { class: "staff-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "d-flex mt-3",
  style: {"gap":"12px"}
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 3,
  class: "d-flex flex-column align-items-center justify-content-center h-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogFrame = _resolveComponent("DialogFrame")!

  return (_openBlock(), _createBlock(_component_DialogFrame, {
    "show-dialog": _ctx.show,
    "on-click-close": _ctx.onClose,
    title: 'パスワードを忘れたら',
    width: 400,
    height: 300
  }, {
    dialogContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.step === 'email')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "メールアドレス", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email",
                    class: "form-control",
                    placeholder: "example@email.com"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "flex-fill btn btn-primary",
                  disabled: !_ctx.email,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmitEmail && _ctx.onSubmitEmail(...args)))
                }, "次へ", 8, _hoisted_5),
                _createElementVNode("button", {
                  class: "flex-fill btn btn-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
                }, "閉じる")
              ])
            ], 64))
          : (_ctx.step === 'loading')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, null, -1)
              ]))]))
            : (_ctx.step === 'select')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.staffList.length > 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "社員IDを選択してください"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.staff_id,
                            class: _normalizeClass(["staff-item", { selected: _ctx.selectedStaffId === item.staff_id }]),
                            onClick: ($event: any) => (_ctx.selectedStaffId = item.staff_id)
                          }, " 社員ID: " + _toDisplayString(item.staff_id), 11, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "flex-fill btn btn-primary",
                      disabled: _ctx.selectedStaffId === null,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitStaffId && _ctx.onSubmitStaffId(...args)))
                    }, "送信", 8, _hoisted_13),
                    _createElementVNode("button", {
                      class: "flex-fill btn btn-secondary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 'email'))
                    }, "戻る")
                  ])
                ], 64))
              : (_ctx.step === 'sent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-center mb-3" }, "パスワードリセットのメールを送信しました。", -1)),
                    _createElementVNode("button", {
                      class: "btn btn-secondary w-75",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
                    }, "閉じる")
                  ]))
                : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show-dialog", "on-click-close"]))
}